import { pluralize } from "@/utils";
import Avatar from "@components/Avatar";
import Tooltip from "@components/Tooltip";

// TODO: convert to <SubscriberBadges /> component
export const getSubscriberBadges = (subscribers, amount, rowKey) => {
  if (!subscribers) return null;

  const filteredSubscribers = subscribers
    .filter((s) => s.full_name !== "")
    .filter((s) => s.interval !== "none");
  const subSlice = filteredSubscribers.slice(0, amount);
  const badges = subSlice.map((subscriber, i) => {
    const [first_name, last_name = ""] = subscriber.full_name.split(" ");
    return (
      <Tooltip
        content={subscriber.full_name}
        delay={{ show: 250, hide: 400 }}
        key={i}
      >
        <Avatar
          size={24}
          key={i}
          subscriber={subscriber}
          full_name={subscriber.full_name}
          last_name={last_name}
          first_name={first_name}
        />
      </Tooltip>
    );
  });

  const restCount = filteredSubscribers.length - amount;

  const restBadge =
    filteredSubscribers.length > amount ? (
      <small key={`row-${rowKey}`} className="more-subscribers text-muted ml-1">
        + {restCount}{" "}
        {pluralize(
          restCount,
          L.REPORTS_LIST_SUBSCRIBERS_BADGE_REST_SINGULAR,
          L.REPORTS_LIST_SUBSCRIBERS_BADGE_REST_PLURAL
        )}
      </small>
    ) : null;

  return badges.concat([restBadge]);
};
